module.exports = __webpack_public_path__ + "static/media/Polaris.415732da.otf";